<template>
    <q-tabs v-if="!$breakpoints.isGreaterThan('sm')" color="faded" inverted>
        <q-route-tab v-for="menu in menus" :key="menu.name" v-ripple slot="title" :to="menu.slug">
            <img :src="devFolder+menu.icon">
            <span class="menu-name">{{ $T(menu.name) }}</span>
        </q-route-tab>
    </q-tabs>
</template>

<script>
    import {
        QTabs,
        QRouteTab
    } from 'quasar-framework'

    export default {
        components: {
            QTabs,
            QRouteTab
        },

        computed: {
            menus() {
                return window.config.menus
            },

            devFolder() {
                return window.config.devAssetsFolder
            }
        },
    }
</script>

<style lang="stylus" scoped>
    .menu-name
        height 30px
        line-height 13px
        font-size 11px
        position relative
        font-weight 600
        display block
        width 60px
        text-align center
        text-transform capitalize
        white-space initial
    .q-layout-footer .q-tabs .q-tab
        padding 10px;
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Footer.vue